export default {"src":"/_next/static/media/icone-potential.a1d17688.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};